
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../tslib/tslib.es6.mjs.js';
import { animations } from '../../motion/features/animations.mjs.js';
import { gestureAnimations } from '../../motion/features/gestures.mjs.js';
import { createDomVisualElement } from './create-visual-element.mjs.js';

/**
 * @public
 */
var domAnimation = __assign(__assign({ renderer: createDomVisualElement }, animations), gestureAnimations);

export { domAnimation };
//# sourceMappingURL=features-animation.mjs.js.map
